import { z } from "zod";

/**
 * Translation config — stored under `{ translation: { ... } }`.
 * _v: 1
 */
export const TranslationPromptConfigSchema = z.object({
  _v: z.literal(1).default(1),
  inputLanguage: z.string(),
  outputLanguage: z.string(),
  lexicalField: z.string().optional(),
  respectLevel: z.number().min(0).max(1).optional()
});

export type TranslationPromptConfig = z.infer<typeof TranslationPromptConfigSchema>;
